import { VMoney } from 'v-money';

const MoneyMixins = {
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      },
    };
  },
  directives: {
    money: VMoney
  },
}

export default MoneyMixins;